var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-image-uploader", class: _vm.computedClass },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.state === _vm.STATE.READY ||
                _vm.state === _vm.STATE.SUCCESS,
              expression: "state === STATE.READY || state === STATE.SUCCESS"
            }
          ],
          staticClass: "uploader-wrap"
        },
        [
          _c("input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.disabled,
                expression: "!disabled"
              }
            ],
            ref: "file",
            staticClass: "_uploader",
            attrs: { type: "file", accept: _vm.acceptTypeStr },
            on: { change: _vm.handleFileChange }
          }),
          _c(
            "div",
            { staticClass: "loader-content" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.state === _vm.STATE.READY,
                      expression: "state === STATE.READY"
                    }
                  ],
                  staticClass: "ready-content"
                },
                [
                  _c("i", { staticClass: "i-image" }),
                  _c("p", {
                    staticClass: "t-ct w-bold color-17181A fs-16 mt-10",
                    domProps: { innerHTML: _vm._s(_vm.placeholder) }
                  })
                ]
              ),
              _vm.value && _vm.value.url
                ? _c("component-image", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.state === _vm.STATE.SUCCESS,
                        expression: "state === STATE.SUCCESS"
                      }
                    ],
                    attrs: {
                      className: "lazy-loader",
                      type: "bg",
                      src: _vm.previewUrl
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.LOAD,
              expression: "state === STATE.LOAD"
            }
          ],
          staticClass: "uploader-wrap"
        },
        [_vm._m(0)]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.ERROR,
              expression: "state === STATE.ERROR"
            }
          ],
          staticClass: "uploader-wrap",
          on: { click: _vm.showReady }
        },
        [
          _c("div", { staticClass: "loader-content" }, [
            _c(
              "div",
              { staticClass: "error-content" },
              [
                _c("Close", {
                  attrs: {
                    color: "#E61717",
                    width: "20px",
                    className: "close-wrap"
                  }
                }),
                _c(
                  "p",
                  { staticClass: "t-ct w-normal color-E61717 fs-16 mt-10" },
                  [_vm._v("上传失败 请重新上传")]
                )
              ],
              1
            ),
            _c("i", { staticClass: "i-reverse" })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader-content" }, [
      _c("div", { staticClass: "c-loader" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }